import { render, staticRenderFns } from "./DemoVideoAnalysis.vue?vue&type=template&id=f5f35180&scoped=true"
import script from "./DemoVideoAnalysis.vue?vue&type=script&lang=js"
export * from "./DemoVideoAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DemoVideoAnalysis.vue?vue&type=style&index=0&id=f5f35180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f35180",
  null
  
)

export default component.exports